
import React, { useState, useEffect } from 'react';
import PostAddIcon from '@material-ui/icons/PostAdd';
import { Box, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Tooltip } from "@material-ui/core";
import Title from "../../Imc/Title";
import { getlist, getlisthash } from '../../domain/api/EvbiApi';
import { ROL_USER, USER_ID } from '../../../app/api-client/constants';
import { useDispatch } from 'react-redux';
import { Store } from 'react-notifications-component';
import TablePagination from '@material-ui/core/TablePagination';


export const ListBasculaAlcohol = ({ rows, openModal, classes }) => {


    const rol_user_login = localStorage.getItem(ROL_USER)
    const dispath = useDispatch();
    const id_user_login = localStorage.getItem(USER_ID)
    const [totalElements, setTotalElements] = useState(0)
    const [basculas, setBasculas] = useState([]);
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    //cambio de pagina
    const handleChangePage = (event, newPage) => {
        setPage(newPage)
        reload("", newPage, rowsPerPage)

    };
    //cambio de tamaño
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        reload("", 0, event.target.value)
        setPage(0)

    };

    const handledAlert = (title, message, type) => {
        Store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 5000,
                onScreen: true
            }
        });
        setTimeout(() => {

        }, 1000);
    }


    const reload = async (filter, page, size) => {

        let basculas = [];

        //Se verifica el rol de usuario para consumir el servicio.
        if (rol_user_login === 'ROLE_ADMIN') {
            basculas = await getlist(dispath, filter, page, size);
        } else {
            basculas = await getlisthash(dispath, id_user_login, filter, page, size);
        }

        try {
            //se setea basculas con el total elements para el tamaño total de la lista
            if (basculas.error !== "Internal Server Error") {
                setTotalElements(basculas.totalElements)
                setBasculas(basculas.content)
            } else {

                setBasculas([])
                handledAlert("Alerta", "No hay basculas asignadas para este usuario", "warning")
            }

        } catch (error) {

        }

    }
    useEffect(async () => {

        reload("", 0, 10);

    }, [])


    return (
        <>
            <Box
                component="span"
                m={1}
                className={`${classes.spreadBox} ${classes.box}`}
            >
                <Title>Estaciones </Title>

            </Box>

            <Table size="small">
                <TableHead>
                    <TableRow align="center" color="primary">
                        <TableCell align="center">Nombre</TableCell>
                        <TableCell align="center">Ubicación</TableCell>
                        <TableCell align="center">Acciones</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody >
                    {basculas.map((row) => (

                        <TableRow key={row.id} >
                            <TableCell align="center">{row.name}</TableCell>
                            <TableCell align="center">{((row.ubicacion.value))}</TableCell>
                            <TableCell align="center" onClick={() => { openModal(row) }} >
                                <IconButton color="primary" >
                                    <Tooltip title="Ver Informacion">
                                        <PostAddIcon />
                                    </Tooltip>
                                </IconButton>
                            </TableCell>


                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <TablePagination
                component="div"
                count={totalElements}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </>
    )

}